import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { CoreService, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, QUESTION_CODES, SECTION_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { Mapper, MapperBuilder, TRANSFORM } from '../../helpers/mapper';
import { CareAllowancePlacementGridFilterRequest } from '../../interfaces/care-allowance-placement-grid-filter-request.interface';
import { AppDataService } from '../../services/app-data.service';
import { ErrorService } from '../../services/error.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';

@Component({
  selector: 'app-care-allowance-placement-list',
  templateUrl: './care-allowance-placement-list.component.html',
  styleUrl: './care-allowance-placement-list.component.scss'
})
export class CareAllowancePlacementListComponent extends BaseCardSetListComponent implements OnInit {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService,
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.careAllowancePlacementList,
      () => {
        return API_ENDPOINTS.dashboard.getCareAllowancePlacements
      },
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.placementIdFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.iccmsPlacementIdFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.oracleVendorIdFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.clientReferenceNumberFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.clientNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.carerReferenceNumberFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.carerNameFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.invoiceNumberFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.invoiceDateFromFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.invoiceDateToFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.paymentNumberFilter)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.paymentDateFromFilter, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.careAllowancePlacementListForm.paymentDateToFilter, TRANSFORM.STRING_TO_DATE)
        .BuildMapper();
  }

  ngOnInit(): void {
  }

  formLoad(event: any): void {
    if (history.state.placementFilterRequest == null) {
      this.loadGridDataOnFormLoad();
    }
    else {
      this.loadGridDataOnFormLoad(history.state.placementFilterRequest);
    }
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.careAllowancePlacementListForm.placementListFilter:
        const filterRequest = this.getFilterRequest();
        this.loadGridData(filterRequest);
        break;
    }
  }

  actionButton_placementGrid_datagrid_colLink_eppPlacementId_Clicked(event: any): void {
    const navExtras = this.getNavigationExtras();
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacement.list, ROUTE_CONSTANTS.careAllowancePlacement.prefix, event.event.data.id], navExtras);
  }

  actionButton_placementGrid_datagrid_colLink_clientPersonReferenceNumber_Clicked(event: any): void {
    const navExtras = this.getNavigationExtras();
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacement.list, ROUTE_CONSTANTS.person.prefixDetail, event.event.data.clientPersonId], navExtras);
  }

  actionButton_placementGrid_datagrid_colLink_carerPersonReferenceNumber_Clicked(event: any): void {
    const navExtras = this.getNavigationExtras();
    this.router.navigate(['/', ROUTE_CONSTANTS.careAllowancePlacement.list, ROUTE_CONSTANTS.person.prefixDetail, event.event.data.carerPersonId], navExtras);
  }

  private getFilterRequest(): CareAllowancePlacementGridFilterRequest {
    const filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.careAllowancePlacementListForm.placements,
      PAGE_NUMBERS.careAllowancePlacementListForm.placements,
      SECTION_CODES.careAllowancePlacementListForm.placementSection,
      QUESTION_CODES.careAllowancePlacementListForm.placementListFilter
    );

    let filterRequest: CareAllowancePlacementGridFilterRequest = this.filterQuestionToFilterModelMapper.Map(filterModel);

    return filterRequest;
  }

  private getNavigationExtras(): NavigationExtras {
    const filterRequest = this.getFilterRequest();

    return {
      state: {
        placementFilterRequest: filterRequest
      }
    };
  }
}
